// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".usage-col{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:0}.usage-col span.bp4-popover2-target{display:inline}", ""]);
// Exports
module.exports = exports;
